import { render } from "./ConvertorInstallModal.vue?vue&type=template&id=6055caf4"
import script from "./ConvertorInstallModal.vue?vue&type=script&lang=js"
export * from "./ConvertorInstallModal.vue?vue&type=script&lang=js"
script.render = render

export default script